/* eslint-disable import/prefer-default-export */
import { useStoreData } from 'stores/hooks';
import { getUser, getUserAsync, getUserRequestStatus } from './userSlice';

export function useUser() {
  return useStoreData(
    getUser,
    getUserRequestStatus,
    getUserAsync,
  );
}
